<!--已出账单 账单明细-->
<template>
  <div class="bill-status-container">
    <span :class="statusClass">{{ billStatus[status] }}</span>
  </div>
</template>

<script>
export default {
  name: 'BilledDetail',
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const billStatus = this.$store.getters.isAgentUser ? {
      1: '待结转',
      2: '已结转',
      3: '待开票',
      4: '待付款',
      5: '付款失败',
      6: '已付款',
    } : {
      3: '待开票',
      5: '付款失败',
      6: '已付款',
    };
    return {
      // 1:待结转，2:已结转，3:待开票 ，4:待付款，5:付款失败，6:已付款
      billStatus,
    };
  },
  computed: {
    statusClass() {
      // 付款失败状态 标红
      return this.status === 5 ? 'tag-status red' : 'tag-status';
    },
  },

};
</script>
<style lang="scss" scoped>
.bill-status-container {
  .tag-status {
    color: #000000;
  }
  .red {
    color: #DD3429;
    font-weight: 500;
  }
}
</style>
